module.exports = __webpack_public_path__ + "img/FNSKU-Combo.cacdc865.png";